/*
 * Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { CurrentUserService, DeviceLabelUpdate, UserCredentialWrapper } from '@administration-client/user-shared';
import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { createEmptyStateResource, StateResource } from '@common/tech-shared';
import { Observable, of } from 'rxjs';
import { TwoFactorComponent } from './two-factor/two-factor.component';

@Component({
  selector: 'administration-two-factor-container',
  imports: [AsyncPipe, TwoFactorComponent],
  templateUrl: './two-factor-container.component.html',
})
export class TwoFactorContainerComponent {
  private readonly currentUserService: CurrentUserService = inject(CurrentUserService);

  public readonly twoFactorDevicesStateResource$: Observable<StateResource<UserCredentialWrapper>> =
    this.currentUserService.getTwoFactorDevices();

  public renameStateResource$: Observable<StateResource<string>> = of(createEmptyStateResource<string>());
  public deleteStateResource$: Observable<StateResource<string>> = of(createEmptyStateResource<string>());

  public addDevice(): void {
    this.currentUserService.addTwoFactorDevice();
  }

  public renameDevice(update: DeviceLabelUpdate): void {
    this.renameStateResource$ = this.currentUserService.renameTwoFactorDevice(update.credentialId, update.label);
  }

  public deleteDevice(credentialId: string): void {
    this.deleteStateResource$ = this.currentUserService.deleteTwoFactorDevice(credentialId);
  }
}
